import noUiSlider from 'nouislider';

export function initRangedPrice(min, max, currency, start, end) {
  const nonLinearSlider = $('.nonlinear');

  nonLinearSlider.each((index, slider) => {
    noUiSlider.create(slider, {
      connect: true,
      behaviour: 'drag',
      start: [Number(start), Number(end)],
      range: {
        min: [Number(min)],
        max: [Number(max)],
      },
    });

    const nodes = [
      $('.lower-value')[index],
      $('.upper-value')[index],
    ];

    const hiddenFields = [
      $('.min-price')[index],
      $('.max-price')[index],
    ];

    slider.noUiSlider.on('update', (values, handle) => {
      nodes[handle].innerHTML = `${currency} ${parseInt(values[handle]).toLocaleString()}`;
      hiddenFields[handle].value = parseInt(values[handle]);
    });

    slider.noUiSlider.on('change', (_value, handle) => {
      $(hiddenFields[handle]).trigger('change');
    });
  });
}

export function initRangedYear(min, max, start, end) {
  const nonLinearSlider = $('.year-nonlinear');

  nonLinearSlider.each((index, slider) => {
    noUiSlider.create(slider, {
      connect: true,
      behaviour: 'drag',
      start: [Number(start), Number(end)],
      range: {
        min: [Number(min)],
        max: [Number(max)],
      },
    });

    const nodes = [
      $('.lower-year')[index],
      $('.upper-year')[index],
    ];

    const hiddenFields = [
      $('.min-year')[index],
      $('.max-year')[index],
    ];

    slider.noUiSlider.on('update', (values, handle) => {
      nodes[handle].innerHTML = parseInt(values[handle]);
      hiddenFields[handle].value = parseInt(values[handle]);
    });

    slider.noUiSlider.on('change', (_value, handle) => {
      $(hiddenFields[handle]).trigger('change');
    });
  });
}

export function initRangedSlider(initOptions) {
  const defaults = {
    min: '0',
    max: '100',
    sign: '',
    start: '10',
    end: '30',
    selector: null,
    submitOnChange: true,
  };

  const options = $.extend({}, defaults, initOptions);

  const mileageSlider = $(`.${options.selector}-slider-target`);

  mileageSlider.each((index, slider) => {
    noUiSlider.create(slider, {
      connect: true,
      behaviour: 'drag',
      start: [Number(options.start), Number(options.end)],
      range: {
        min: Number(options.min),
        max: Number(options.max),
      },
    });

    const nodes = [
      $(`.lower-${options.selector}`)[index],
      $(`.upper-${options.selector}`)[index],
    ];


    const hidden_fields = [
      $(`.min-${options.selector}`)[index],
      $(`.max-${options.selector}`)[index],
    ];

    slider.noUiSlider.on('update', (values, handle) => {
      nodes[handle].innerHTML = parseInt(values[handle]).toLocaleString() + options.sign;
      hidden_fields[handle].value = parseInt(values[handle]);
    });

    const parentForm = $(slider).closest('form');
    slider.noUiSlider.on('change', () => {
      if (options.submitOnChange && parentForm.length) {
        parentForm.submit();
      }
    });
  });
}

export function initBuyLeadsSlider(max) {
  const slider = document.querySelector('#leads-count-slider');
  const leadsTotalPrice = $('#leads-total-price');
  const numberOfleadInput = $('#number-of-leads');
  const min = Number(max) === 1 ? 0 : 1;

  noUiSlider.create(slider, {
    start: Number(max),
    step: 1,
    connect: [true, false],
    range: {
      min,
      max: Number(max),
    },
  });

  if (min === 0) { slider.noUiSlider.target.setAttribute('disabled', true); }

  slider.noUiSlider.on('update', (values, handle) => {
    const leadsCount = parseInt(values[handle]);
    numberOfleadInput.val(leadsCount);
    let price = Math.round(leadsTotalPrice.data('price-per-one') * leadsCount * 100) / 100;
    if (price < 1) { price = 1; }
    $('#leads-count').text(leadsCount);
    leadsTotalPrice.text(price);
  });

  return slider.noUiSlider;
}



// WEBPACK FOOTER //
// ./app/webpacker/src/js/ranged_slider_settings.js